import {
  qiniuUploadUrl,
  qiniuImageURLPrefix,
  qiniuExportURLPrefix,
  shopDefault,
} from "@/config/qiniu";
import { getOptimizeImgUrl } from "@/utils/index";
import store from "@/store";
import { mapGetters } from "vuex";
export default {
  install: function (Vue) {
    Vue.mixin({
      data() {
        return {
          tableHeight: window.innerHeight - 200,
          tableLoading: false,
          page: 0,
          isTableDataHasMore: true,
          MIXIN_TableLodingText: "正在加载",
          qiniuUploadUrl: qiniuUploadUrl,
          qiniuImageURLPrefix: qiniuImageURLPrefix,
          qiniuExportURLPrefix: qiniuExportURLPrefix,
          shopDefault: shopDefault,
        };
      },

      created() {
        this.tableLoadingTimer = null;
      },
      computed: {
        // 传参数计算表格高度
        tablesHeight() {
          return function (val) {
            let tem = this.innerHeight > 0 ? 0 : this.innerHeight;
            val = val == undefined ? 230 : val;
            return window.innerHeight + 40 - val - tem;
          };
        },
        ...mapGetters(["innerHeight"]),
      },

      methods: {
        // canGoIn(permission, userinfo) {
        //     if (userinfo) {
        //         return permission.some(item => {
        //             userinfo.module_permissions_list.indexOf(item)
        //         })
        //     }
        //     return permission.some(item => {
        //         store.state.userInfo.module_permissions_list.indexOf(item)
        //     })
        // },
        /*
         * @防抖动
         * @params fn fucntion 操作触发的函数
         * @params callback fucntion 防抖结束后触发的函数
         * @params timeout number 防抖最小的持续时间
         */
        /*
         * @用法
         *   <template>
         *        <button @click="()=>{$throttle(submit)}">提交表单</button>
         *   </template>
         *   *********
         *  methods:{
         *       submit(){
         *           return new Promise((res, rej) => {
         *              const form = { account:'senguo',password:'123456'}
         *              const promiseLogin = login(form)
         *              const promiseOtherThing = otherRequest()
         *              Promise.all([promiseLogin,promiseOtherThing]).finally(()=>{
         *                  // 无论结果如何最后都调用一次 res()
         *                  res()
         *              })
         *           }
         *       }
         *  }
         */
        $debounce(fn, callback, timeout = 1000 * 1) {
          if (fn.disable === true) {
            return console.log("防抖作用于：" + fn.name);
          } else {
            fn.disable = true;
            const timeoutPromise = new Promise((res) => {
              setTimeout(res, timeout);
            });
            Promise.all([fn(), timeoutPromise]).finally(() => {
              fn.disable = false;
              callback && callback();
            });
          }
        },
        initScrollTable(isTableDataHasMore = true) {
          this.page = 0;
          this.isTableDataHasMore = isTableDataHasMore;
        },

        // 用于监听表格滚动，以及加载数据
        scrollLoad(data) {
          this.$emit("tableScroll", data);
          if (this.tableLoading) {
            return;
          } else if (
            data.direction === "up" ||
            data.distanceRelativeToBottom > 100
          ) {
            return;
          }

          this.tableLoading = true;
          // 执行获取数据函数
          if (this.isTableDataHasMore && this.getTableList) {
            let count = 0;
            this.tableLoadingTimer = setInterval(() => {
              this.MIXIN_TableLodingText =
                "正在加载" + [".", "..", "..."][count++ % 3];
            }, 350);
            this.getTableList(++this.page)
              .then((datas) => {
                this.isTableDataHasMore = datas.has_more;
                console.log(datas.has_more, "datas.has_more");
                return datas;
              })
              .finally(() => {
                this.tableLoading = false;
                clearInterval(this.tableLoadingTimer);
              });
          } else {
            this.tableLoading = false;
          }
        },

        openMessage(code, message, options = {}) {
          let type;
          switch (code) {
            case 0:
              type = "error";
              break;
            case 1:
              type = "success";
              break;
            case 2:
              type = "info";
              break;
            default:
              break;
          }
          this.$message({
            type,
            message,
            showClose: true,
            duration: options.duration || 2000,
          });
        },

        openNotify(code, message, title) {
          let type, typeText;
          switch (code) {
            case 0:
              type = "error";
              typeText = "失败";
              break;
            case 1:
              type = "success";
              typeText = "成功";
              break;
            case 2:
              type = "info";
              typeText = "提示";
              break;
            default:
              break;
          }
          this.$notify({
            title: title || typeText,
            message: message,
            type: type,
          });
        },

        getOptimizeImgUrl(path, size = 200) {
          getOptimizeImgUrl(path, size);
        },

        //异步更新队列
        async nextTick(beforeTick, afterTick) {
          beforeTick && beforeTick();
          await this.$nextTick();
          afterTick && afterTick();
        },

        cloneObject(obj) {
          // 深克隆一个对象
          return JSON.parse(JSON.stringify(obj));
        },
      },
    });
  },
};
